import { state } from "../store";

export async function getCoordsCity(city) {
    let formatedCity = city.replaceAll(" ", "+");
    const urlApiGouv = encodeURI(`https://geo.api.gouv.fr/communes?nom=${formatedCity}&fields=centre`);
    const coords = [];

    await fetch(urlApiGouv)
        .then(response => response.json())
        .then(data => {
            coords.lon = data[0].centre.coordinates[0];
            coords.lat = data[0].centre.coordinates[1];
        });

    return coords;
}

export async function getCity(city) {
    let formatedcity = city.replaceAll(" ", "+");
    const urlApiGouv = encodeURI(`https://geo.api.gouv.fr/communes?nom=${formatedcity}&fields=departement,codesPostaux,centre`);

    await fetch(urlApiGouv)
        .then(response => response.json())
        .then(data => {
            state.listCities = data.slice(0, 5);
        });
}